export default __webpack_public_path__ + "static/media/25.ab4591b5.jpg";